import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { useOutsideClick } from '../hooks';
import styles from './Modal.module.css';
import classNames from 'classnames';
var Modal = function (_a) {
    var visible = _a.visible, close = _a.close, className = _a.className, children = _a.children, outsideClick = _a.outsideClick;
    var containerRef = useRef(null);
    outsideClick && useOutsideClick(containerRef, function () { return outsideClick(); });
    useEffect(function () {
        if (visible) {
            document.body.style.width = '100%';
            document.body.style.overflow = 'hidden';
        }
        else {
            document.body.style.width = 'initial';
            document.body.style.overflow = 'initial';
        }
    }, [visible]);
    var element = visible ? (React.createElement("div", { className: styles.backdrop, onClick: function (event) { return event.stopPropagation(); } },
        React.createElement("div", { ref: containerRef, className: classNames(styles.container, className) },
            React.createElement("div", { className: styles.closeButtonContainer },
                React.createElement("button", { className: styles.closeButton, onClick: close })),
            children))) : null;
    return createPortal(element, document.getElementById('root'));
};
export default Modal;
